var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header py-7 py-lg-4 pt-lg-9"}),_c('b-container',{staticClass:"mt--8 pb-5"},[_c('div')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }